import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { PureCustomValueData } from "PFTypes";
import { useCallback } from "react";

import { SmartSuggestionsList } from "./smart_suggestions_list";

type SuggestedKeywordsProps = {
  items: PureCustomValueData[];
};

export const SuggestedKeywords = ({ items }: SuggestedKeywordsProps) => {
  const dispatch = useSearchDispatch();
  const {
    search: { pendingKeywordSearch, suggestedKeywordsCyclePage }
  } = useSearchStoreContext();
  const { data: currentProfile } = useCurrentProfile();

  const pushChoosenKeyword = useCallback((payload: PureCustomValueData) => {
    const type = SEARCH_ACTIONS.SEARCH_PUSH_CHOOSEN_KEYWORD;
    dispatch({ type, payload });
  }, []);

  const cycle = useCallback((payload?: number) => {
    const type = SEARCH_ACTIONS.SEARCH_SUGGESTED_KEYWORDS_CYCLCE_PAGE_INCREMENT;
    dispatch({ type, payload });
  }, []);

  return (
    <div style={{ opacity: pendingKeywordSearch ? 0.5 : 1 }}>
      <SmartSuggestionsList
        items={items}
        onAdd={pushChoosenKeyword}
        cycle={cycle}
        cycleOffset={suggestedKeywordsCyclePage - 1}
        usedOn="search"
        userId={currentProfile.id}
      />
    </div>
  );
};
